import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { ProblemSection } from './components/sections/ProblemSection';
import { FamiliarSection } from './components/sections/FamiliarSection';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { MethodSection } from './components/sections/MethodSection';
import { ModulesSection } from './components/sections/ModulesSection';
import { ToolsSection } from './components/sections/ToolsSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { OfferSection } from './components/sections/OfferSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { AuthorSection } from './components/sections/AuthorSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-sand-50" data-id="element-0" data-mp="3rbrakqf99zft">
      <MetaPixel data-id="element-1" data-mp="3rcswjpxt86cb" />
      <Hero data-id="element-2" data-mp="3recdlirailf5" />
      <main data-id="element-3" data-mp="5yk6vxnnffx">
        <ProblemSection data-id="element-4" data-mp="5orh0l86u6j" />
        <FamiliarSection data-id="element-5" data-mp="4wv3njt0sf7" />
        <BeforeAfter data-id="element-6" data-mp="56nfhsbnbo2" />
        <MethodSection data-id="element-7" data-mp="7ssnarqpf34" />
        <ModulesSection data-id="element-8" data-mp="2zllf11m4wkmq" />
        <ToolsSection data-id="element-9" data-mp="2zm4xqkjlzd1t" />
        <BonusesSection data-id="element-10" data-mp="2zmwj72jhrued" />
        <OfferSection data-id="element-11" data-mp="2znfy0adui2o6" />
        <GuaranteeSection data-id="element-12" data-mp="33m5cy7ej7s9x" />
        <TestimonialsSection data-id="element-13" data-mp="33ngee0ki8nxv" />
        <AuthorSection data-id="element-14" data-mp="33orjc3pos1qk" />
        <FaqSection data-id="element-15" data-mp="38m1fs3bhtdnw" />
        <FinalCta data-id="element-16" data-mp="38li7zffk45nl" />
      </main>
      <Footer data-id="element-17" data-mp="38k6wetfvdtlx" />
      <FloatingCTA data-id="element-18" data-mp="38nuqbtp88i16" />
      <PurchasePopup data-id="element-19" data-mp="3dkuw03i5zirr" />
    </div>;
}